import { connect } from 'react-redux';
import Component from './component';
import setContactIDRoute from '../../actions/contacts/contactidroute';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  handleSetContactIDRoute: async (command) => {
    await dispatch(await setContactIDRoute(command));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
